import { render, staticRenderFns } from "./ClassScoreSummary.vue?vue&type=template&id=767e151b"
import script from "@/controllers/custom/score_summary/class-score-summary.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/score_summary/class-score-summary.js?vue&type=script&lang=js&external"
import style0 from "./ClassScoreSummary.vue?vue&type=style&index=0&id=767e151b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports